import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '../icon/icon.module';

import { ButtonToggleComponent } from './button-toggle.component';

@NgModule({
  declarations: [ButtonToggleComponent],
  imports: [CommonModule, IconModule],
  exports: [ButtonToggleComponent],
})
export class ButtonToggleModule {}
